import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { moduleName, type PostEditingState } from "./post-editing.types";

const initialState: PostEditingState = {
	editingPostId: null,
};

const postEditingSlice = createSlice({
	name: moduleName,
	initialState,
	reducers: {
		setEditingPost: (state, action: PayloadAction<string | null>) => {
			state.editingPostId = action.payload;
		},
	},
});

export default postEditingSlice;
